import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export interface Checklist {
    id: number;
    name: string;
    project_id: number;
    version: number;
    status: string;
}

export interface ChecklistItem {
    id: number;
    checklist_id: number;
    text: string;
    order: number;
    item_type: string;
    item_subtype?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ChecklistService {

    constructor(private http: HttpClient) { }

    public getChecklistForProject(projectId: number): Observable<Checklist[]> {
        const path = environment.apiURL + `projects/${projectId}/checklists.json`;
        return this.http.get<Checklist[]>(path);
    }

    public getChecklistItems(checklistId: number): Observable<ChecklistItem[]> {
        const path = environment.apiURL + `checklists/${checklistId}/items.json`;
        return this.http.get<ChecklistItem[]>(path);
    }

    public getChecklistForTicket(ticketId: number): Observable<Checklist> {
        return this.http.get<Checklist>(`/r/api/v1/tickets/${ticketId}/checklist.json`);
    }
}
